import { contentInstanse } from '@ts/utils/axios';
import { ApiRequestError } from '@ts/utils/errors';

export async function fetchBlogs(params = {}, rest = {}) {
    return contentInstanse
        .get('public/blog/', { params, ...rest })
        .then(({ data }) => {
            if (data && typeof data === 'object' && data.items) {
                return data;
            }
            throw new ApiRequestError('Failed fetch blogs: /public/blog/', params);
        })
        .catch((err) => {
            throw new ApiRequestError(`Failed fetch blogs: /public/blog/ ${err.message}`, rest);
        });
}

export async function fetchByCategory(category_id, params = {}) {
    return fetchBlogs({
        category_id,
        ...params,
    });
}

export async function fetchBySlug(slug, rest = {}) {
    return contentInstanse
        .get(`public/blog/${slug}`, rest)
        .then(({ data }) => {
            if (data && typeof data === 'object') {
                return data;
            }
            throw new ApiRequestError(`Failed fetchBySlug: public/blog/${slug}`, rest);
        })
        .catch((err) => {
            throw new ApiRequestError(
                `Failed fetchBySlug: public/blog/${slug} ${err.message}`,
                rest
            );
        });
}
